import update from 'immutability-helper';

export const setOrderField = (state, field, value) =>
  update(state, { [field]: { $set: value } });
